module.exports = require('./dist/lightstep-tracer.min.js');
